import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress, Typography } from '@mui/material';
const LoadingSpinner = ({ size = 40, message = 'Loading...', color = 'primary', fullScreen = false, }) => {
    const content = (_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, children: [_jsx(CircularProgress, { size: size, color: color }), message && (_jsx(Typography, { variant: "body2", color: "text.secondary", children: message }))] }));
    if (fullScreen) {
        return (_jsx(Box, { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "rgba(255, 255, 255, 0.8)", zIndex: 9999, children: content }));
    }
    return content;
};
export default LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map